/* eslint-disable max-lines */
import { data as dossierData } from '@lba-dev/package.local-globals/dossier';
import subStatus from '@lba-dev/package.local-globals/aSubStatus';
import categories from '@lba-dev/package.local-globals/categories';
import status from '@lba-dev/package.local-globals/aStatus';

import DefaultArtisanMenu from '../../components/List/Artisan/ArtisanMenu';
import ArchiveArtisanMenu
  from '../../components/List/Artisan/ArchiveArtisanMenu';
import DefaultArtisanActions
  from '../../components/List/Artisan/ArtisanActions';
import NoRibArtisanActions
  from '../../components/List/Artisan/NoRibArtisanActions';
import { Types } from './Types';
import store from '../../store';
import sourceLogoArtisans from '../sourceLogoArtisans';

export const List = {
  default: {
    dataFormat: {
      table: {
        ID: Types.Text,
        Ajout: Types.RefId,
        Création: Types.Text,
        Equipe: Types.Equipe,
        Catégories: Types.Rectangle,
        'Nom de société': Types.Text,
        Artisan: Types.Text,
        Ville: Types.Text,
        Dossier: Types.Chip,
        Statut: Types.Chip,
        'Sous-statut': Types.Chip,
        Rémunération: Types.Pourcentage,
        Payées: Types.Text,
        Vérifiées: Types.Text,
      },
      tableData: [
        { class: 'th' },
        { class: 'width-110', list: store.getState().users, key: 'login' },
        { class: 'width-100' },
        { class: 'width-100' },
        { class: '', list: categories.data },
        { class: '', logoArtisan: sourceLogoArtisans, sourceArtisan: 'source' },
        { class: '' },
        { class: '' },
        { class: '', list: dossierData },
        { class: '', list: status.data },
        { class: '', list: subStatus.data },
        { class: 'centerText' },
        { class: 'centerText' },
        { class: 'centerText' },
      ],
      keys: [
        'id',
        'login.ajout',
        'date.ajout',
        'equipe.billingAddress.zipcode',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'status',
        'subStatus',
        'remuneration',
        'interPayer',
        'verifiedInterventions',
      ],
      checkType: [
        'number',
        'users',
        'date',
        'equipeAreasArtisan',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'artisanStatus',
        'substatus',
        'remuneration',
        'number',
        'number',
      ],
    },
    menu: DefaultArtisanMenu,
    actions: DefaultArtisanActions,
  },
  debr: {
    dataFormat: {
      table: {
        ID: Types.Text,
        Ajout: Types.RefId,
        'Prise en charge': Types.RefId,
        Création: Types.Text,
        Catégories: Types.Rectangle,
        'Nom de société': Types.Text,
        Artisan: Types.Text,
        Ville: Types.Text,
        Dossier: Types.Chip,
        Statut: Types.Chip,
        'Sous-statut': Types.Chip,
        Rémunération: Types.Pourcentage,
        Payées: Types.Text,
        Vérifiées: Types.Text,
        '1ère Vérif': Types.Text,
        'Debrief': Types.Debrief,
      },
      tableData: [
        { class: 'th' },
        { class: 'width-110', list: store.getState().users, key: 'login' },
        { class: 'width-110', list: store.getState().users, key: 'login' },
        { class: 'width-100' },
        { class: '', list: categories.data },
        { class: '', logoArtisan: sourceLogoArtisans, sourceArtisan: 'source' },
        { class: '' },
        { class: '' },
        { class: '', list: dossierData },
        { class: '', list: status.data },
        { class: '', list: subStatus.data },
        { class: 'centerText' },
        { class: 'centerText' },
        { class: 'centerText' },
        { class: 'width-100' },
        { class: 'width-100' },
      ],
      keys: [
        'id',
        'login.ajout',
        'login.debrief',
        'date.ajout',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'status',
        'subStatus',
        'remuneration',
        'interPayer',
        'verifiedInterventions',
        'date.firstVerif',
        'debriefProcess',
      ],
      checkType: [
        'number',
        'users',
        'debriefUser',
        'date',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'artisanStatus',
        'substatus',
        'remuneration',
        'number',
        'number',
        'date',
        'number'
      ],
    },
    menu: DefaultArtisanMenu,
    actions: DefaultArtisanActions,
  },
  ribNoValide: {
    dataFormat: {
      table: {
        ID: Types.Text,
        Ajout: Types.RefId,
        Création: Types.Text,
        Catégories: Types.Rectangle,
        'Nom de société': Types.Text,
        Artisan: Types.Text,
        Ville: Types.Text,
        Dossier: Types.Chip,
        Statut: Types.Chip,
        'Sous-statut': Types.Chip,
        Rémunération: Types.Pourcentage,
        Rib: Types.Rib,
        Zone: Types.Equipe
      },
      tableData: [
        { class: 'th' },
        { class: '', list: store.getState().users, key: 'login' },
        { class: '' },
        { class: '', list: categories.data },
        { class: '', logoArtisan: sourceLogoArtisans, sourceArtisan: 'source' },
        { class: '' },
        { class: '' },
        { class: '', list: dossierData },
        { class: '', list: status.data },
        { class: '', list: subStatus.data },
        { class: 'width-100' },
        { class: '' },
        { class: 'width-100' }
      ],
      keys: [
        'id',
        'login.ajout',
        'date.ajout',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'status',
        'subStatus',
        'remuneration',
        'Rib',
        'equipe.billingAddress.zipcode',
      ],
      checkType: [
        'number',
        'users',
        'date',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'artisanStatus',
        'substatus',
        'remuneration',
        'rib',
        'equipeAreasArtisan'
      ],
    },
    menu: DefaultArtisanMenu,
    actions: DefaultArtisanActions,
  },
  paidnoRib: {
    dataFormat: {
      table: {
        ID: Types.Text,
        Ajout: Types.RefId,
        Création: Types.Text,
        Catégories: Types.Rectangle,
        'Nom de société': Types.Text,
        Artisan: Types.Text,
        Ville: Types.Text,
        Dossier: Types.Chip,
        Statut: Types.Chip,
        'Sous-statut': Types.Chip,
        Rémunération: Types.Pourcentage,
        Payées: Types.Text,
        Vérifiées: Types.Text,
        Reglées: Types.Text,
      },
      tableData: [
        { class: 'th' },
        { class: 'width-110', list: store.getState().users, key: 'login' },
        { class: 'width-100' },
        { class: '', list: categories.data },
        { class: '', logoArtisan: sourceLogoArtisans, sourceArtisan: 'source' },
        { class: '' },
        { class: '' },
        { class: '', list: dossierData },
        { class: '', list: status.data },
        { class: '', list: subStatus.data },
        { class: 'centerText' },
        { class: 'centerText' },
        { class: 'centerText' },
        { class: 'centerText' },
      ],
      keys: [
        'id',
        'login.ajout',
        'date.ajout',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'status',
        'subStatus',
        'remuneration',
        'interPayer',
        'verifiedInterventions',
        'interReglesVerif',
      ],
      checkType: [
        'number',
        'users',
        'date',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'artisanStatus',
        'substatus',
        'remuneration',
        'number',
        'number',
        'number',
      ],
    },
    menu: DefaultArtisanMenu,
    actions: NoRibArtisanActions,
  },
  arcpro: {
    dataFormat: {
      table: {
        ID: Types.Text,
        Ajout: Types.RefId,
        'Archivé par': Types.RefId,
        Création: Types.Text,
        'Date d\'archive': Types.Text,
        Catégories: Types.Rectangle,
        'Nom de société': Types.Text,
        Artisan: Types.Text,
        Ville: Types.Text,
        Dossier: Types.Chip,
        Statut: Types.Chip,
        'Sous-statut': Types.Chip,
        Rémunération: Types.Pourcentage,
      },
      tableData: [
        { class: 'th' },
        { class: '', list: store.getState().users, key: 'login' },
        { class: '', list: store.getState().users, key: 'login' },
        { class: '' },
        { class: '' },
        { class: '', list: categories.data },
        { class: '', logoArtisan: sourceLogoArtisans, sourceArtisan: 'source' },
        { class: '' },
        { class: '' },
        { class: '', list: dossierData },
        { class: '', list: status.data },
        { class: '', list: subStatus.data },
        { class: '' },
      ],
      keys: [
        'id',
        'login.ajout',
        'login.archive',
        'date.ajout',
        'date.archive',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'status',
        'subStatus',
        'remuneration',
      ],
      checkType: [
        'number',
        'users',
        'users',
        'date',
        'date',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'artisanStatus',
        'substatus',
        'remuneration',
      ],
    },
    menu: ArchiveArtisanMenu,
    actions: DefaultArtisanActions,
  },
  relance: {
    dataFormat: {
      table: {
        ID: Types.Text,
        Ajout: Types.RefId,
        'Prochaine relance': Types.Text,
        Catégories: Types.Rectangle,
        'Nom de société': Types.Text,
        Artisan: Types.Text,
        Ville: Types.Text,
        Rémuneration: Types.Pourcentage,
      },
      tableData: [
        { class: 'th' },
        { class: '', list: store.getState().users, key: 'login' },
        { class: '' },
        { class: '', list: categories.data },
        { class: '', logoArtisan: sourceLogoArtisans, sourceArtisan: 'source' },
        { class: '' },
        { class: '' },
        { class: '' },
      ],
      keys: [
        'id',
        'login.ajout',
        'date.reminder',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        'remuneration',
      ],
      checkType: [
        'number',
        'login.ajout',
        'date',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        'remuneration',
      ],
    },
  },
  traCan: {
    dataFormat: {
      table: {
        ID: Types.Text,
        Ajout: Types.RefId,
        Création: Types.Text,
        Equipe: Types.Equipe,
        'Source de candidature': Types.Text,
        Catégories: Types.Rectangle,
        'Nom de société': Types.Text,
        Artisan: Types.Text,
        Ville: Types.Text,
        Dossier: Types.Chip,
        Statut: Types.Chip,
        'Sous-statut': Types.Chip,
        Rémunération: Types.Pourcentage,
        Payées: Types.Text,
        Vérifiées: Types.Text,
      },
      tableData: [
        { class: 'th' },
        { class: 'width-110', list: store.getState().users, key: 'login' },
        { class: 'width-100' },
        { class: 'width-100' },
        { class: '' },
        { class: '', list: categories.data },
        { class: '' },
        { class: '' },
        { class: '' },
        { class: '', list: dossierData },
        { class: '', list: status.data },
        { class: '', list: subStatus.data },
        { class: 'centerText' },
        { class: 'centerText' },
        { class: 'centerText' },
      ],
      keys: [
        'id',
        'login.ajout',
        'date.ajout',
        'equipe.billingAddress.zipcode',
        'source',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'status',
        'subStatus',
        'remuneration',
        'interPayer',
        'verifiedInterventions',
      ],
      checkType: [
        'number',
        'users',
        'date',
        'equipeAreasArtisan',
        'source',
        'categories',
        'companyName',
        ['name', 'firstname'],
        ['billingAddress.zipcode', 'billingAddress.city'],
        '_dossier',
        'artisanStatus',
        'substatus',
        'remuneration',
        'number',
        'number',
      ],
    },
    menu: DefaultArtisanMenu,
    actions: DefaultArtisanActions,
  },
};
